module.exports = "<app-header></app-header>\r\n<div class=\"container-fluid mt-4\">\r\n<router-outlet></router-outlet>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/app/shared/layout/shell/shell.component.html
// module id = ../../../../../src/app/shared/layout/shell/shell.component.html
// module chunks = main